import { useEffect } from 'react';

import { useCommentsModalState, useCommentsModalActions } from './CommentsModalContext';

import { getComments } from '../../Feed/components/restApi';

const CommentsModalLoader = ({ parentId, parentType }) => {
  const state = useCommentsModalState();
  const { initializeState, onResponse, onError } = useCommentsModalActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    if (state?.commentsModal && !state?.commentsModal?.commentDataLoaded) {
      getComments({
        parentId,
        parentType,
        onResponse,
        onError,
      });
    }
  }, [state?.commentsModal?.commentDataLoaded, parentId, parentType]);

  return null;
};

export default CommentsModalLoader;
